
$('.home-hero-header').waypoint(function(direction) {
    //
})